import React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import { tokens } from '../../theme/tokens';

export const TableCard: React.FC<{
  title?: string;
  subtitle?: string;
  actions?: React.ReactNode;
  children: React.ReactNode;
  /** Remove inner padding (useful when wrapping a full-bleed table/grid). */
  flush?: boolean;
}> = ({ title, subtitle, actions, children, flush }) => {
  const hasHeader = !!(title || subtitle || actions);
  return (
    <Card sx={{ borderRadius: `${tokens.radius.lg}px`, borderColor: tokens.color.border, boxShadow: 'none', height: '100%' }}>
      <CardContent sx={{ p: flush ? 0 : 2.25, '&:last-child': { pb: flush ? 0 : 2.25 } }}>
        {hasHeader ? (
          <>
            <Box
              sx={{
                px: flush ? 2.25 : 0,
                pt: flush ? 2 : 0,
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                gap: 2,
                flexWrap: 'wrap',
              }}
            >
              <Box sx={{ minWidth: 0 }}>
                {title ? (
                  <Typography variant="subtitle1" sx={{ fontWeight: 650 }}>
                    {title}
                  </Typography>
                ) : null}
                {subtitle ? (
                  <Typography variant="caption" sx={{ color: tokens.color.textSecondary }}>
                    {subtitle}
                  </Typography>
                ) : null}
              </Box>
              {actions ? <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', flexWrap: 'wrap' }}>{actions}</Box> : null}
            </Box>
            <Divider sx={{ mt: 1.5, mb: flush ? 0 : 2, ...(flush ? { mx: 0 } : {}) }} />
          </>
        ) : null}
        {children}
      </CardContent>
    </Card>
  );
};
